export const GET_PRODUCT = 'GET_PRODUCT';
export const REDUCE_PRODUCT = 'REDUCE_PRODUCT';
